module.exports = "/assets/1926cea551a7650ea70469322cb5dbf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/HZ.png
// module id = 1457
// module chunks = 0